export default "__VITE_ASSET__f0864e08__"